import { html, ref } from '@microsoft/fast-element';
import { sync } from '@genesislcap/foundation-utils';
import type { SettlementForecast } from './settlement-forecast';
import { GRAPH_PERIODICITY, GRAPH_SCENARIO } from '../../../../../utils/enums/generic.enum';

export enum OPTIONS_ENUM {
  P05 = 'P05',
  MEAN = 'Mean',
  P95 = 'P95',
}

export const SettlementForecastTemplate = html<SettlementForecast>`
<div class="graph-div">
  <div class="criteria-selection">
        <div class="scenario-control">
        <label class="control-label">Scenario</label>
          <multi-segmented-control
            appearance="primary"
            orientation="horizontal"
            :options="${(x) => Object.values(GRAPH_SCENARIO)}"
            :selectedOptions="${(x) => x.selectedScenarios}"
            @selectionChange=${(x, c) => x.updateScenariosOptions(c.event as CustomEvent)}
          >
          </multi-segmented-control>
        </div>
        <div class="periodicity-control">
          <label class="control-label">Periodicity</label>
          <zero-segmented-control
            appearance="primary"
            orientation="horizontal"
            :value="${sync((x) => x.periodicity)}"
          >
            <zero-segmented-item value=${GRAPH_PERIODICITY.MONTHLY} class="custom-segmented-item">
              Monthly
            </zero-segmented-item>
            <zero-segmented-item value=${GRAPH_PERIODICITY.QUATERLY} class="custom-segmented-item">
              Quarterly
            </zero-segmented-item>
            <zero-segmented-item value=${GRAPH_PERIODICITY.YEARLY} class="custom-segmented-item">
              Yearly
            </zero-segmented-item>
          </zero-segmented-control>
        </div>
        <div class="periodicity-control">
          <label class="control-label">Settlement Outcomes</label>
          <multi-segmented-control
            appearance="primary"
            orientation="horizontal"
            :options="${(x) => Object.values(OPTIONS_ENUM)}"
            :selectedOptions="${(x) => x.selectedSettlements}"
            @selectionChange=${(x, c) => x.updateSettlementOutcomesOptions(c.event as CustomEvent)}
          >
          </multi-segmented-control>
        </div>
        <div class="periodicity-control">
          <label class="control-label">Cash Flows</label>
          <multi-segmented-control
            appearance="primary"
            orientation="horizontal"
            :options="${(x) => Object.values(OPTIONS_ENUM)}"
            :selectedOptions="${(x) => x.selectedCashFlows}"
            @selectionChange=${(x, c) => x.updateCashFlowOptions(c.event as CustomEvent)}
          >
          </multi-segmented-control>
        </div>
      </div>
      <div style="height: 100%; display: ${(x) => (x.isVisible ? '' : 'none')}" ${ref(
  'settlementForecastChart'
)}></div>
    </div>
  </div>
</div>
      
`;
